import { createContext } from 'react';

type ShowAlertProps = {
  headerText: string;
  detailText: string;
  dismissText: string;
  variant: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'dark' | 'light';
  err?: any;
};

type AlertContextProps = {
  onDismiss: () => void;
  showAlert: (props: ShowAlertProps) => void;
  headerText: string;
  detailText: string;
  dismissText: string;
  variant: string;
  isVisible: boolean;
};

const initialContextValues: AlertContextProps = {
  onDismiss: () => {},
  showAlert: () => {},
  headerText: '',
  detailText: '',
  dismissText: '',
  variant: '',
  isVisible: false,
};

/**
 * See {@link AlertContextProps}
 */
const AlertContext = createContext<AlertContextProps>(initialContextValues);

export default AlertContext;
export type { AlertContextProps, ShowAlertProps };
